import type { FC, ReactNode } from 'react';

import { textRecipe, TextVariants } from './Text.css';
import { extractDataProps } from '../../util/attributes';
import { getClassNames } from '../../util/css';

export const Text: FC<TextProps> = ({
  align,
  'aria-hidden': ariaHidden,
  as: Component = 'span',
  children,
  className = '',
  color,
  dangerouslySetInnerHTML,
  display,
  id,
  size,
  weight,
  whiteSpace,
  ...rest
}) => {
  const dataSet = extractDataProps(rest);
  const textStyle = textRecipe({ weight, size, color, align, whiteSpace, display });

  return (
    <Component
      {...dataSet}
      aria-hidden={ariaHidden}
      className={getClassNames('sparky-text', textStyle, className)}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      id={id}>
      {children}
    </Component>
  );
};

Text.toString = () => '.sparky-text';

type TextProps = TextVariants & {
  children?: ReactNode;
  /** The DOM element to render */
  as?: Extract<
    keyof JSX.IntrinsicElements,
    | 'caption'
    | 'div'
    | 'span'
    | 'section'
    | 'article'
    | 'abbr'
    | 'summary'
    | 'details'
    | 'legend'
    | 'address'
    | 'figcaption'
    | 'p'
    | 'aside'
    | 'bdi'
    | 'th'
    | 'td'
    | 'cite'
    | 'code'
    | 'dt'
    | 'dd'
    | 'dfn'
    | 'del'
    | 'ins'
    | 'li'
  >;
  /** For usage with ARIA attributes */
  id?: string;
  dangerouslySetInnerHTML?: { __html: string };
  className?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
};
